// extracted by mini-css-extract-plugin
export default {"registration-button":"SZWjF","registrationButton":"SZWjF","disabled":"cAtL0","link":"_2Hy58"};